var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-footer"},[_c('div',{staticClass:"site-copyright"},[_c('p',{staticClass:"site-copyright__text"},[_vm._v(" © Copyright "+_vm._s(_vm.actualYear)+" - Dominion DMS ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }